import { motion } from "framer-motion";
import Hero from "@/components/Hero";
import StatsBar from "@/components/StatsBar";
import TargetGroups from "@/components/TargetGroups";
import AnlassGrid from "@/components/AnlassGrid";
import LocationTeaser from "@/components/LocationTeaser";

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.5 } },
  exit: { opacity: 0, transition: { duration: 0.3 } },
};

export default function Home() {
  return (
    <motion.main
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      data-testid="home-page"
    >
      <Hero />
      <StatsBar />
      <TargetGroups />
      <AnlassGrid />

      {/* Art meets Party Quote Block */}
      <section className="relative py-20 md:py-28 overflow-hidden bg-[#1C1C1E]" data-testid="quote-section">
        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p
              className="text-[#C1440E] text-xs tracking-[0.4em] uppercase mb-8"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Das Leitmotiv
            </p>
            <blockquote
              className="text-4xl md:text-6xl lg:text-7xl text-[#F2EDE8] leading-tight mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic" }}
              data-testid="quote-block"
            >
              "Art meets Party"
            </blockquote>
            <p
              className="text-[#A19D98] text-sm md:text-base max-w-2xl mx-auto leading-relaxed"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Die Verbindung aus Künstlerhof-Atmosphäre und Feierlichkeit ist das
              Alleinstellungsmerkmal des Atelier 77. Klaus Teichmann ist Künstler,
              kein Eventmanager – das soll man spüren.
            </p>
          </motion.div>
        </div>
      </section>

      <LocationTeaser />
    </motion.main>
  );
}
